module.exports = __webpack_public_path__ + "static/media/Sentient_BossPhase.83d5a361.gif";